import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const user = useSelector((state) => state.user.user);
  const location = useLocation();

  if (user !== null) return children;
  else return <Navigate to="/login" state={{ from: location }} replace />;
};

export default PrivateRoute;
